import { render, staticRenderFns } from "./ComboCard.vue?vue&type=template&id=3af611a1&scoped=true"
import script from "./ComboCard.vue?vue&type=script&lang=js"
export * from "./ComboCard.vue?vue&type=script&lang=js"
import style0 from "./ComboCard.vue?vue&type=style&index=0&id=3af611a1&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af611a1",
  null
  
)

export default component.exports